module.exports = __webpack_public_path__ + "static/David-and-Goliath-062a9978414efc20bf3a1cf61576fa21.svg";